import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as styles from './Previews.scss';

var IntroPreview = /*#__PURE__*/function (_Component) {
  _inherits(IntroPreview, _Component);

  var _super = _createSuper(IntroPreview);

  function IntroPreview() {
    var _this;

    _classCallCheck(this, IntroPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderBulletItems", function () {
      var items = _this.props.formValues.introBullets.filter(function (bullet) {
        return bullet !== '';
      });

      return items.map(function (bullet, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: styles.introListItem,
          key: index
        }, bullet);
      });
    });

    return _this;
  }

  _createClass(IntroPreview, [{
    key: "render",
    value: function render() {
      var formValues = this.props.formValues;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.previewWrap
      }, formValues.introEnabled && /*#__PURE__*/React.createElement("h2", {
        className: styles.headline
      }, formValues.introHeadline), formValues.introEnabled && formValues.introLayoutType === 0 && formValues.introParagraph && /*#__PURE__*/React.createElement("p", {
        className: styles.introParagraph
      }, formValues.introParagraph), formValues.introEnabled && formValues.introLayoutType === 1 && formValues.introBullets[0] && /*#__PURE__*/React.createElement("ul", {
        className: styles.introList
      }, this.renderBulletItems()));
    }
  }]);

  return IntroPreview;
}(Component);

export { IntroPreview as default };